// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Hero__Wrapper_258Gw","Head":"Hero__Head_19CsB grid","Title":"Hero__Title_W8_l8"};